import React, { useContext, useEffect } from "react";
import ListItem from "../Table/ListItem";
import THead from "../Table/THead";

import "./customer.css";
import { Context } from "../../utils/context";

const Customer = () => {
  const { agentPerf, setAgentPerf } = useContext(Context);
  useEffect(() => {
    fetch("http://api.realtalk.reallytics.ai/agent-performance")
      .then((res) => res.json())
      .then((res) => setAgentPerf(res))
      .catch((e) => console.log(e)); 
  },[]);
  const headItems = [
    "Total Calls",
    "Confidence",
    "Professionalism",
    "Understanding",
    "Report",
  ];

  return (
    <>
      <div className="customer-container">
        <THead headItems={headItems} />
        <div className="table-data">
          {agentPerf?.map((item, index) => {
            return (
              <ListItem
                key={index}
                item={item}
                headItemsQuantity={headItems.length}
              />
            );
          })}
        </div>
      </div>
    </>
  );
};

export default Customer;
